<template>
  <label
    for="file-drag-and-drop"
    @drop.prevent="dropFile"
    @dragover.prevent="handleEnterInZone"
    @dragleave.prevent="handleLeaveZone"
    :data-active="draggingInZone"
    class="drag-and-drop-container"
  >
    <jade-text
      :color="draggingInZone ? 'positive' : 'medium'"
      weight="semibold"
      class="pointer-events-none text-center"
      >{{ $t('drag-and-drop.title') }}</jade-text
    >
    <jade-text
      color="medium"
      variant="small"
      class="text-center pointer-events-none"
    >
      {{ $t('instructions', { limit }) }}
    </jade-text>
    <jade-button
      variant="neutral-subtle"
      size="medium"
      icon="action-export"
      class="pointer-events-none"
      >{{ $t('upload.button') }}</jade-button
    >
    <input
      id="file-drag-and-drop"
      type="file"
      class="hidden"
      ref="file"
      @change="onChange"
      :multiple="multiple"
    />
  </label>
</template>
<script>
import { JadeText, JadeButton } from '@jade'
export default {
  name: 'FileDragAndDrop',
  components: {
    JadeText,
    JadeButton
  },
  data () {
    return {
      draggingInZone: false,
      files: []
    }
  },
  props: {
    multiple: Boolean,
    limit: {
      type: Number,
      default: 15
    }
  },
  methods: {
    handleEnterInZone (e) {
      this.draggingInZone = true
    },
    handleLeaveZone (e) {
      this.draggingInZone = false
    },
    onChange () {
      this.files.push(...this.$refs.file.files)
      this.$emit('update:files', this.files)
    },
    dropFile (e) {
      this.$refs.file.files = e.dataTransfer.files
      this.onChange()
      this.draggingInZone = false
    }
  }
}
</script>
<i18n>
    {
        "pt-BR": {
            "drag-and-drop.title": "Arraste e solte a documentação aqui",
            "upload.button": "Carregar documentos",
            "instructions": "Os documentos devem estar no formato PDF ou JPG e não pode exceder o limite de tamanho combinado de {limit}MB."
        },
        "en-US": {
            "drag-and-drop.title": "Drag and drop the documentation here",
            "upload.button": "Upload documents",
            "instructions": "Documents must be in PDF or JPG format and cannot exceed the combined size limit of {limit}MB."
        }
    }
</i18n>
<style scoped>
.drag-and-drop-container {
  @apply w-full min-h-44 flex flex-col py-4 px-20 items-center justify-center gap-4 border-2 border-dashed rounded-xl cursor-pointer data-[active=true]:border-jade-background-positive;
}
</style>
